import { render, staticRenderFns } from "./SectionBestSellers.vue?vue&type=template&id=0fb9cef0"
import script from "./SectionBestSellers.vue?vue&type=script&lang=js"
export * from "./SectionBestSellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports